// extracted by mini-css-extract-plugin
export var ellipsis = "OpenWithButton-module--ellipsis--O87o+";
export var instructions = "OpenWithButton-module--instructions--LsRAt";
export var root = "OpenWithButton-module--root--og3B6";
export var tooltipFootnote = "OpenWithButton-module--tooltipFootnote--MBpEG";